import { API_URL } from 'utilities/environment';

export const ApiEndpoints = {
  WIDGET_DEMO: `${API_URL}/front/widget/demo`,
  WIDGET: `${API_URL}/front/widget/${window.wbtxReviewsUtils.shopDomain}`,
  ADD_REVIEW: `${API_URL}/front/review/${window.wbtxReviewsUtils.shopDomain}`,
  GEOLOCATION: `https://reviews-front.gowebtex.com/wbtx-geo/${window.wbtxReviewsUtils.shopDomain}`,
  VOTE: `${API_URL}/front/vote/${window.wbtxReviewsUtils.shopDomain}`,
  IMAGE_UPLOAD: `${API_URL}/front/img/${window.wbtxReviewsUtils.shopDomain}`,
} as const;
